import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-hotel-card-loader',
  templateUrl: './hotel-card-loader.component.html',
  styleUrls: ['./hotel-card-loader.component.scss']
})
export class HotelCardLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  hotelCardLoader: OwlOptions = {
    loop: true,
    margin: 15,
    autoplay: true,
    autoplayHoverPause: true,
    autoplaySpeed: 950,
    navSpeed: 700,
    dots: false,
    nav: false,
    responsive: {
      0: {
        items: 1
      },
      425: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      }
    }
  }
}
